<!--FastBI产品-->
<template>
  <div class="renewDialog">
    <el-dialog :before-close="restForm" title="增购产品模块" :visible.sync="visible" :close-on-click-modal="false"
      width="560px" v-loading="loading">
      <el-form :model="form" ref="form" :rules="formRules">

        <el-form-item :label-width="formLabelWidth" label="授权码" prop="code">
          <el-input v-model="form.code" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="授权客户名称" prop="name">
          <el-input v-model="form.name" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" v-if="n_module.length > 0" label="功能模块" prop="fbi_edition">
          <el-checkbox-group v-model="form.new_modules">
            <el-checkbox v-for="(item, index) in n_module" :key="index" :label="item.code">{{
              item.name
            }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" v-if="suit.length > 0" label="应用模块" prop="fbi_edition">
          <el-checkbox-group v-model="form.apps">
            <el-checkbox v-for="(item, index) in suit" :key="index" :label="item.id">{{
              item.name
            }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="购买方式" prop="buy_type">
          <el-radio-group v-model="form.buy_type" @change="buy_type_change">
            <el-radio :label="1">买断模式</el-radio>
            <el-radio :label="2">按年订阅</el-radio>
            <el-radio :label="3">申请试用</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item :label-width="formLabelWidth" v-if="form.buy_type == 2" :label="'购买时长'">
          <el-input-number style="text-align: center;" size="small" v-model="form.new_months" :min="1" :max="100"
            :step="1"></el-input-number>
          <span style="margin-left: 10px;">年</span>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" v-if="form.buy_type == 3" :label="'试用时长'">
          <el-select v-model="form.trail_days" filterable placeholder="请选择">
            <el-option :key="7" label="七天" :value="7"> </el-option>
            <el-option :key="15" label="十五天" :value="15"> </el-option>
            <el-option :key="30" label="一个月" :value="30"> </el-option>
          </el-select>
        </el-form-item>
        <!-- <div v-if="form.buy_type != 3">
          <el-form-item :label-width="formLabelWidth" label="支付方式" prop="pay_type">
            <el-radio-group v-model="form.pay_type">
              <el-radio :label="1">FastBI产品专用币优先</el-radio>
              <el-radio :label="2">通用币优先</el-radio>
            </el-radio-group>
          </el-form-item>
        </div> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <div class="price">订单:<span>¥10000</span></div> -->
        <el-button @click="cancel('form', (visible = false))">取 消</el-button>
        <el-button v-if="form.buy_type == 3" class="primary" @click="triallClick">申请试用</el-button>
        <el-button v-else class="primary" @click="buyClick">预览价格</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  buyPrice,
  buy,
  modify_price,
  modify,
  getProductEditions,
  getProductModules,
  addTrail,
  add_module,
  add_module_price,
  trail_module,

} from "@/api/auth";
import { getModule, getModuleAuthParam } from '@/api/module';
import { getSuit } from '@/api/suit';

import { payType } from "@/utils/dataDict";
import { payVerify } from "@/utils/pay";
export default {
  data() {
    return {
      new_expire_time: "",
      modifyId: null,
      isAdd: "add",
      currentBuyTime: null,
      payType,
      visible: false,
      formLabelWidth: "110px",
      form: {
        name: "",
        code: "",
        key: "",
        contact_name: "",
        phone: "",
        email: "",
        months: null,
        pay_type: 1,
        fbi_edition: "",
        modules: [],
        note: "",
        buy_type: 1,
        new_months: 1,
        apps: [],
        new_modules: [],
        trail_days:30
      },
      formRules: {
        name: [
          {
            required: true,
            message: "请输入授权客户名称",
            trigger: "blur",
          },],
        code: [
          {
            required: true,
            message: "请输入授权码",
            trigger: "blur",
          },
          {
            pattern: /^[0-9a-zA-Z]{1,}$/,
            message: "只支持输入数字、字母",
            trigger: "blur",
          },],
        key: [
          {
            required: true,
            message: "请输入授权码密码",
            trigger: "blur",
          },
          {
            pattern: /^[0-9a-zA-Z]{1,}$/,
            message: "只支持输入数字、字母",
            trigger: "blur",
          },],
        contact_name: [
          {
            required: true,
            message: "请输入客户联系人",
            trigger: "blur",
          },],
        phone: [
          {
            required: true,
            message: "请输入联系人电话",
            trigger: "blur",
          },],
        email: [
          {
            required: true,
            message: "请输入联系人邮箱",
            trigger: "blur",
          },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: "blur",
          },],
      },
      isSelectAll: false,
      modules: [],
      buyTime: [
        { name: "一年", value: 12 },
        { name: "两年", value: 24 },
        { name: "三年", value: 36 },
        { name: "买断", value: 10000 },
      ],
      edittions: [],
      lockModuels: {}, //必须跟着版本购买的模块
      currentSelectModuels: [],
      moduleMap: {},
      n_module: [], //模块
      suit: [],
      loading: false
    };
  },
  mounted() {
    window.test = this;

    // 
  },
  methods: {
    changeBuyDate() {
      this.accreditDate();
    },
    getSuitData() {
      //获取应用列表
      this.loading = true;
      getSuit()
        .then((response) => {
          this.loading = false;
          this.suit = response;
          console.log(this.suit);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getModuleData() {
      //获取模块列表
      this.loading = true;
      getModule()
        .then((response) => {
          this.loading = false;
          response.forEach((item) => {
            this.moduleMap[item.name] = item.charge_type;
          });
          this.n_module = response;
          console.log(this.n_module);

        })
        .catch(() => {
          this.loading = false;
        });
    },
    accreditDate() {
      let date = new Date(this.form.expire_time);
      if (this.isAdd != "edit") {
        date = new Date();
        this.form.expire_time = `${date.getFullYear()}-${this.formatDate(
          date.getMonth() + 1
        )}-${this.formatDate(date.getDate())}`;
      }
      if (this.form.expire_time == "买断") {
        //过期时间为买断
        this.new_expire_time = "买断";
      } else if (this.form.expire_time && date >= new Date()) {
        //判断有过期时间并且在没过期时间范围内
        if (this.form.months === 0) {
          //购买时长为只购买模块
          this.new_expire_time = `${date.getFullYear()}-${this.formatDate(
            date.getMonth() + 1
          )}-${this.formatDate(date.getDate())}`;
        } else if (this.form.months === 10000) {
          //购买时长为买断
          this.new_expire_time = "买断";
        } else {
          //购买时长N(1)年
          date.setMonth(date.getMonth() + this.form.months);
          this.new_expire_time = `${date.getFullYear()}-${this.formatDate(
            date.getMonth() + 1
          )}-${this.formatDate(date.getDate())}`;
        }
      }
    },
    getBuyMonths(code) {
      if (!this.lockModuels[code]) {
        if (this.currentSelectModuels.indexOf(code) != -1) {
          if (this.form.expire_time) {
            let date = new Date(this.form.expire_time);
            let now = new Date();
            if (now < date) {
              //未过期
              return `${this.form.months}个月+补购${Math.floor(
                (date - now) / 86400000
              )}天`;
            }
          }
        }
      }
      return this.form.months + "个月";
    },
    formatDate(num) {
      let result = num + "";
      if (result.length < 2) {
        result = "0" + result;
      }
      return result;
    },
    show(obj) {
      this.form = {
        name: "",
        code: "",
        key: "",
        contact_name: "",
        phone: "",
        email: "",
        months: 12,
        pay_type: 1,
        fbi_edition: "",
        modules: [],
        note: "",
        buy_type: 1,
        new_months: 1,
        apps: [],
        new_modules: [],
        trail_days:30
      };
      this.getModuleData()
      this.getSuitData();
      this.buyTime = [
        { name: "一年", value: 12 },
        { name: "两年", value: 24 },
        { name: "三年", value: 36 },
        { name: "买断", value: 10000 },
      ]
      this.visible = true;
      if (obj) {
        this.modifyId = obj.id;
        this.form.name = obj.name;
        this.form.code = obj.code;
      }
      this.accreditDate();
      // this.getEditions();
    },
    triallClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let modules = this.form.new_modules.join(",")
          let suits = this.form.apps.join(",")
          let obj = {
            trail_days: this.form.trail_days,
            // modules: modules,
            // suits: suits
          };
          if (!modules && !suits) {
            this.$message({
              type: "error",
              message: "至少选择一个需要增购的模块!",
            });
          } else {
            if (modules) obj['modules'] = modules
            if (suits) obj['suits'] = suits
            trail_module(this.modifyId, obj)
              .then(() => {
                this.loading = false;
                this.$message({
                  type: "success",
                  message: "申请试用成功",
                });
                this.$parent.getAuthData();
                this.form = {
                  name: "",
                  code: "",
                  key: "",
                  contact_name: "",
                  phone: "",
                  email: "",
                  months: null,
                  pay_type: 1,
                  fbi_edition: "",
                  modules: [],
                  note: "",
                  buy_type: 1,
                  new_months: 1,
                  apps: [],
                  new_modules: [],
                  trail_days:30
                },
                  this.visible = false
                this.loading = false;
              })
              .catch(() => {
                this.loading = false;
              });
          }

        }
      });
    },

    buy_type_change(val) {
      // if (val == 2) {
      //   this.form.months = 1
      // }
    },
    buyClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let buyout = false
          if (this.form.buy_type == 1) {  //买断
            buyout = true
            this.form.months = 10000
          } else if (this.form.buy_type == 2) {
            buyout = false
            this.form.months = Number(this.form.new_months) * 12
          }
          let modules = this.form.new_modules.join(",")
          let suits = this.form.apps.join(",")
          let obj = {
            months: this.form.months,
            pay_type: this.form.pay_type,

          };
          obj.buyout = buyout
          if (!modules && !suits) {
            this.$message({
              type: "error",
              message: "至少选择一个需要增购的模块!",
            });
          } else {
            if (modules) obj['modules'] = modules
            if (suits) obj['suits'] = suits
            this.buySubmit(obj);
          }

        }
      });
    },
    buySubmit(priceObj) {
      add_module_price(this.modifyId, priceObj)
        .then((res) => {
          if (res.warning_code == 1001) {
            this.$message({
              type: 'error',
              dangerouslyUseHTMLString: true,
              message: `<p style="margin-bottom:5px">检测到您增购模块的到期时间晚于产品授权码有效期（授权到期后所有功能将不可用）。</p>
                        <p>建议您先续购买产品授权后增购模块或调整增购模块的购买期限。</p>`,
            });

          }
          this.$store
            .dispatch("user/userinfo") //获取账户余额
            .then(() => {
              this.loading = false;
              let finance = {
                special: this.$store.getters.userInfo.finance.fbi_point,
                universal: this.$store.getters.userInfo.finance.point,
              };
              let parms = {
                price: res.total,
                payType: this.form.pay_type,
              };
              let result = payVerify(parms, finance, 'FastBI产品'); //检测余额是否足够
              this.$confirm(`${result.msg}，是否购买？`, "支付信息", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  add_module(this.modifyId, priceObj).then((res) => {
                    this.$message({
                      type: "success",
                      message: "购买成功!",
                    });
                    this.visible = false;
                    this.$parent.getAuthData();
                  });
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "已取消购买",
                  });
                });
            });

        })
        .catch((err) => { });
    },
    modifyBuySubmit(obj) {
      let priceObj = {
        pay_type: this.form.pay_type,
        months: this.form.months,
        // modules: this.currentSelectModuels.join(","),
      };
      modify_price(this.modifyId, priceObj)
        .then((res) => {
          this.$store
            .dispatch("user/userinfo") //获取账户余额
            .then(() => {
              this.loading = false;
              let finance = {
                special: this.$store.getters.userInfo.finance.fbi_point,
                universal: this.$store.getters.userInfo.finance.point,
              };
              let parms = {
                price: res.total,
                payType: this.form.pay_type,
              };
              let result = payVerify(parms, finance, 'FastBI产品'); //检测余额是否足够
              this.$confirm(`${result.msg}，是否购买？`, "支付信息", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  modify(this.modifyId, obj).then((res) => {
                    this.$message({
                      type: "success",
                      message: "购买成功!",
                    });
                    this.visible = false;
                    this.$parent.getAuthData();
                  });
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "已取消购买",
                  });
                });
            });
        })
        .catch((err) => { });
    },
    restForm(done) {
      this.cancel();

      done();
    },
    cancel(formName, close) {
      this.form = {
        name: "",
        code: "",
        key: "",
        contact_name: "",
        phone: "",
        email: "",
        months: 12,
        pay_type: 1,
        fbi_edition: "",
        modules: [],
        new_modules: [],   // 功能模块
        apps: [],   // 应用模块
        note: "",
        buy_type: 1,
        new_months: 1,
        trail_days:30
      };
      this.modifyId = null;
      this.isAdd = "add";
    },
    checkSelctRow(row) {
      if (row.code == this.lockModuels[row.code]) {
        return false;
      } else {
        return true;
      }
    },
    selectChange(selection, row) {
      this.currentSelectModuels = selection.map((val) => {
        return val.code;
      });
    },
    selectAllChange(selection) {
      this.currentSelectModuels = selection.map((val) => {
        return val.code;
      });
      //全选、反全选
      // this.isSelectAll = !this.isSelectAll;
      // if (this.isSelectAll == false) {
      //   this.$refs.elTable.clearSelection();
      // } else {
      //   selection.forEach((item) => {
      //     if (item.children) {
      //       item.children.forEach((item) => {
      //         this.$refs.elTable.toggleRowSelection(item, true);
      //       });
      //     }
      //   });
      // }
    },
    changeMonths(item) {
      console.log(item);
      if (item.buyout_valid && item.valid) {
        this.buyTime = [
          { name: "一年", value: 12 },
          { name: "两年", value: 24 },
          { name: "三年", value: 36 },
          { name: "买断", value: 10000 },
        ]
      } else if (item.buyout_valid) {
        this.buyTime = [
          { name: "买断", value: 10000 },
        ]
      } else if (item.valid) {

        this.buyTime = [
          { name: "一年", value: 12 },
          { name: "两年", value: 24 },
          { name: "三年", value: 36 }
        ]
      }
    },



  },
};
</script>
<style lang="scss" scoped>
.renewDialog {

  /deep/ .el-dialog__body {
    padding: 30px 20px 0px 20px !important;
  }

  .info {
    margin: 10px 5px;
    border: 1px solid rgb(233, 233, 233);
    border-radius: 10px;
    box-shadow: rgba(0, 0, 0, 0.047) 0px 0px 5px;

    .input_box {
      padding: 0 50px;
      margin-top: 20px;

      // margin-bottom: 10px;
      .block {
        display: inline-block;
        margin-right: 85px !important;
        margin-top: 0 !important;
        margin-bottom: 10px !important;
        width: 178px;

        .autocomplete {
          width: 100%;
        }

        .el-form-item {
          margin-bottom: 0px;
        }
      }

      .block:last-child {
        margin-right: 0 !important;
      }

      .label {
        margin-bottom: 5px;
        font-size: 13px;

        span {
          color: #ff0000;
        }
      }
    }

    .title {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      border-bottom: 1px solid rgb(233, 233, 233);
      font-size: 16px;
      font-weight: 650;
      padding: 15px 20px;
      background: #f9f9f9;
    }
  }

  .company_info {
    padding-bottom: 20px;
  }

  .authorization_info {
    .context {
      padding: 20px 50px;

      p {
        font-size: 13px;
        margin-bottom: 5px;
      }
    }
  }

  .pay_info {
    padding-bottom: 20px;
  }

  .price {
    float: left;
    text-align: left;
    font-size: 16px;

    span {
      color: #ff0000;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/product/buyModule.vue